// Available filter definitions for the criteria builder
export const FILTER_DEFS = [
  {
    id: "rsi_lt",
    category: "Momentum",
    label: "RSI < 30 (Aşırı Satım)",
    build: () => ({ type: "rsi", op: "lt", value: 30 }),
    describe: (f) => `RSI < ${f.value}`,
  },
  {
    id: "rsi_gt",
    category: "Momentum",
    label: "RSI > 70 (Aşırı Alım)",
    build: () => ({ type: "rsi", op: "gt", value: 70 }),
    describe: (f) => `RSI > ${f.value}`,
  },
  {
    id: "rsi_between",
    category: "Momentum",
    label: "RSI 40-60 (Nötr)",
    build: () => ({ type: "rsi", op: "between", value: 40, value2: 60 }),
    describe: (f) => `RSI ${f.value}-${f.value2}`,
  },
  {
    id: "macd_golden",
    category: "Trend",
    label: "MACD Altın Kesişim",
    build: () => ({ type: "macd_status", op: "eq", value: "golden_cross" }),
    describe: () => "MACD Altın Kesişim",
  },
  {
    id: "macd_bullish",
    category: "Trend",
    label: "MACD Yükseliş",
    build: () => ({ type: "macd_status", op: "eq", value: "bullish" }),
    describe: () => "MACD Yükseliş",
  },
  {
    id: "macd_death",
    category: "Trend",
    label: "MACD Ölüm Kesişimi",
    build: () => ({ type: "macd_status", op: "eq", value: "death_cross" }),
    describe: () => "MACD Ölüm Kesişimi",
  },
  {
    id: "ma_golden",
    category: "Trend",
    label: "EMA 20/50 Altın Kesişim",
    build: () => ({ type: "ma_status", op: "eq", value: "golden_cross" }),
    describe: () => "EMA 20/50 Altın",
  },
  {
    id: "ma_bullish",
    category: "Trend",
    label: "EMA 20 > EMA 50",
    build: () => ({ type: "ma_status", op: "eq", value: "bullish" }),
    describe: () => "EMA 20>50",
  },
  {
    id: "bb_upper",
    category: "Volatilite",
    label: "Bollinger Üst Kırılım",
    build: () => ({ type: "bb_status", op: "eq", value: "upper_break" }),
    describe: () => "BB Üst Kırılım",
  },
  {
    id: "bb_lower",
    category: "Volatilite",
    label: "Bollinger Alt Kırılım",
    build: () => ({ type: "bb_status", op: "eq", value: "lower_break" }),
    describe: () => "BB Alt Kırılım",
  },
  {
    id: "vol_spike_2x",
    category: "Hacim",
    label: "Hacim Patlaması (>2x)",
    build: () => ({ type: "volume_ratio", op: "gt", value: 2 }),
    describe: (f) => `Hacim > ${f.value}x`,
  },
  {
    id: "vol_spike_3x",
    category: "Hacim",
    label: "Hacim Patlaması (>3x)",
    build: () => ({ type: "volume_ratio", op: "gt", value: 3 }),
    describe: (f) => `Hacim > ${f.value}x`,
  },
  {
    id: "pct_gt_5",
    category: "Fiyat",
    label: "% Değişim > 5",
    build: () => ({ type: "pct_change", op: "gt", value: 5 }),
    describe: (f) => `% > ${f.value}`,
  },
  {
    id: "pct_lt_neg5",
    category: "Fiyat",
    label: "% Değişim < -5",
    build: () => ({ type: "pct_change", op: "lt", value: -5 }),
    describe: (f) => `% < ${f.value}`,
  },
];

export function describeFilter(f) {
  const def = FILTER_DEFS.find((d) => {
    const b = d.build();
    return b.type === f.type && b.op === f.op && (b.value === f.value);
  });
  if (def) return def.describe(f);
  return `${f.type} ${f.op} ${f.value}`;
}
